import { useQuery } from '@tanstack/react-query';

import { fetchStripeClientSecret, InvalidStripeClientSecretError } from '@m/services/StripeService';
import {
  trackClientSecretFailed,
  trackClientSecretPrepared,
} from 'apps/customer/utils/paymentMethodHeap';

// Stripe setup intents expire after 24h — cache for 23h with a 1h buffer
const STRIPE_SECRET_CACHE_MS = 23 * 60 * 60 * 1000;

export function useStripeClientSecret(userId: number | null | undefined, enabled = true) {
  return useQuery({
    queryKey: ['stripeClientSecret', userId],
    queryFn: async () => {
      const startedAt = performance.now();
      try {
        const clientSecret = await fetchStripeClientSecret(userId as number);
        trackClientSecretPrepared({
          clientSecret,
          durationMs: Math.round(performance.now() - startedAt),
        });
        return clientSecret;
      } catch (error) {
        trackClientSecretFailed({
          durationMs: Math.round(performance.now() - startedAt),
          error,
          invalidSecret: error instanceof InvalidStripeClientSecretError,
        });
        throw error;
      }
    },
    enabled: !!userId && enabled,
    retry: 1,
    staleTime: STRIPE_SECRET_CACHE_MS,
    gcTime: STRIPE_SECRET_CACHE_MS,
  });
}
